/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ProductCategories {
  angular.module("meevo.plugins.productCategories", []);
}